export var IdAssetBundleBalancing;
(function (IdAssetBundleBalancing) {
    IdAssetBundleBalancing["Constants"] = "Constants";
    IdAssetBundleBalancing["CoopLevels"] = "CoopLevels";
    IdAssetBundleBalancing["CoopSettings"] = "CoopSettings";
    IdAssetBundleBalancing["CoopProjects"] = "CoopProjects";
    IdAssetBundleBalancing["Farms"] = "Farms";
    IdAssetBundleBalancing["Expansions"] = "Expansions";
    IdAssetBundleBalancing["Buildings"] = "Buildings";
    IdAssetBundleBalancing["Resources"] = "Resources";
    IdAssetBundleBalancing["Quests"] = "Quests";
    IdAssetBundleBalancing["QuestIntros"] = "QuestIntros";
    IdAssetBundleBalancing["Recipes"] = "Recipes";
    IdAssetBundleBalancing["PlayerLevels"] = "PlayerLevels";
    IdAssetBundleBalancing["UiDefinitions"] = "UiDefinitions";
    IdAssetBundleBalancing["ContractOrders"] = "ContractOrders";
    IdAssetBundleBalancing["ContractRewards"] = "ContractRewards";
    IdAssetBundleBalancing["Characters"] = "Characters";
    IdAssetBundleBalancing["Outskirts"] = "Outskirts";
    IdAssetBundleBalancing["FarmEvents"] = "FarmEvents";
    IdAssetBundleBalancing["ProfilePictures"] = "ProfilePictures";
    IdAssetBundleBalancing["PurchaseOfferGroups"] = "PurchaseOfferGroups";
    IdAssetBundleBalancing["PurchaseOfferShiftLevels"] = "PurchaseOfferShiftLevels";
    IdAssetBundleBalancing["RandomPools"] = "RandomPools";
    IdAssetBundleBalancing["Packages"] = "Packages";
    IdAssetBundleBalancing["LanguageSettings"] = "LanguageSettings";
    IdAssetBundleBalancing["LibraryImprovements"] = "LibraryImprovements";
    IdAssetBundleBalancing["MarketImprovements"] = "MarketImprovements";
    IdAssetBundleBalancing["Buffs"] = "Buffs";
    IdAssetBundleBalancing["BalloonOfferContents"] = "BalloonOfferContents";
    IdAssetBundleBalancing["BalloonOfferTypes"] = "BalloonOfferTypes";
    IdAssetBundleBalancing["PVPMapDefinitions"] = "PVPMapDefinitions";
})(IdAssetBundleBalancing || (IdAssetBundleBalancing = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/IdAssetBundleBalancing.ts
// module id = 448
// module chunks = 3